/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as ChatImport } from './routes/chat'
import { Route as IndexImport } from './routes/index'
import { Route as ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlImport } from './routes/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm.html'
import { Route as CallbackLoginZaloWebImport } from './routes/callback.login.zalo-web'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ChatRoute = ChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute =
  ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlImport.update({
    id: '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html',
    path: '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html',
    getParentRoute: () => rootRoute,
  } as any)

const CallbackLoginZaloWebRoute = CallbackLoginZaloWebImport.update({
  id: '/callback/login/zalo-web',
  path: '/callback/login/zalo-web',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html': {
      id: '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html'
      path: '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html'
      fullPath: '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html'
      preLoaderRoute: typeof ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlImport
      parentRoute: typeof rootRoute
    }
    '/callback/login/zalo-web': {
      id: '/callback/login/zalo-web'
      path: '/callback/login/zalo-web'
      fullPath: '/callback/login/zalo-web'
      preLoaderRoute: typeof CallbackLoginZaloWebImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/chat': typeof ChatRoute
  '/login': typeof LoginRoute
  '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html': typeof ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute
  '/callback/login/zalo-web': typeof CallbackLoginZaloWebRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/chat': typeof ChatRoute
  '/login': typeof LoginRoute
  '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html': typeof ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute
  '/callback/login/zalo-web': typeof CallbackLoginZaloWebRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/chat': typeof ChatRoute
  '/login': typeof LoginRoute
  '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html': typeof ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute
  '/callback/login/zalo-web': typeof CallbackLoginZaloWebRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chat'
    | '/login'
    | '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html'
    | '/callback/login/zalo-web'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chat'
    | '/login'
    | '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html'
    | '/callback/login/zalo-web'
  id:
    | '__root__'
    | '/'
    | '/chat'
    | '/login'
    | '/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html'
    | '/callback/login/zalo-web'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChatRoute: typeof ChatRoute
  LoginRoute: typeof LoginRoute
  ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute: typeof ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute
  CallbackLoginZaloWebRoute: typeof CallbackLoginZaloWebRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChatRoute: ChatRoute,
  LoginRoute: LoginRoute,
  ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute:
    ZaloverifierEDxa6kSneGvkW7nl9SMZZYocJKb1iD3CmHtmlRoute,
  CallbackLoginZaloWebRoute: CallbackLoginZaloWebRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/chat",
        "/login",
        "/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html",
        "/callback/login/zalo-web"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/chat": {
      "filePath": "chat.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html": {
      "filePath": "zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm.html.tsx"
    },
    "/callback/login/zalo-web": {
      "filePath": "callback.login.zalo-web.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
